import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Logo from "../assets/images/user.png";
import { updateUsername, updatePassword, onLoggedin } from "../actions";
import axios from "axios";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
      errorMessage: "",
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isLoad: false,
      });
    }, 500);
    document.body.classList.remove("theme-cyan");
    document.body.classList.remove("theme-purple");
    document.body.classList.remove("theme-blue");
    document.body.classList.remove("theme-green");
    document.body.classList.remove("theme-orange");
    document.body.classList.remove("theme-blush");
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { username, password } = this.props;

    try {
      const response = await axios.post("https://brand.aasmo.in/api/admin/login  ", {
        username: username,
        password: password,
      });

      // Assuming the token is returned in response.data.token
      if (response.data.token) {
        // Store the token in local storage
        localStorage.setItem("authToken", response.data.token);
        // Update Redux state
        this.props.onLoggedin(response.data.token);
        // Redirect to the dashboard
        this.props.history.push("/dashboard");
      } else {
        this.setState({ errorMessage: "Invalid username or password." });
      }
    } catch (error) {
      // Handle error
      console.error("Login error:", error);
      this.setState({ errorMessage: "An error occurred during login." });
    }
  };

  render() {
    return (
      <div className="theme-cyan">
        <div
          className="page-loader-wrapper"
          style={{ display: this.state.isLoad ? "block" : "none" }}
        >
          <div className="loader">
            <div className="m-t-30">
              <img
                src={require("../assets/images/user.png")}
                width="48"
                height="48"
                alt="Lucid"
              />
            </div>
            <p>Please wait...</p>
          </div>
        </div>
        <div className="hide-border">
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main">
              <div className="auth-box">
                {/* <div className="top">
                  <img
                    src={Logo}
                    alt="Lucid"
                    style={{ height: "100px", margin: "0px" }}
                  />
                </div> */}
                <div className="card">
                  <div className="header">
                    <p className="lead">Login to your account</p>
                  </div>
                  <div className="body">
                    <form className="form-auth-small" onSubmit={this.handleSubmit}>
                      <div className="form-group">
                        <label className="control-label sr-only">Username</label>
                        <input
                          className="form-control"
                          id="signin-username"
                          placeholder="Username"
                          type="text"
                          value={this.props.username}
                          onChange={(val) =>
                            this.props.updateUsername(val.target.value)
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label sr-only">Password</label>
                        <input
                          className="form-control"
                          id="signin-password"
                          placeholder="Password"
                          type="password"
                          value={this.props.password}
                          onChange={(val) =>
                            this.props.updatePassword(val.target.value)
                          }
                        />
                      </div>
                      <div className="form-group clearfix">
                        <label className="fancy-checkbox element-left">
                          <input type="checkbox" />
                          <span>Remember me</span>
                        </label>
                      </div>
                      <button
                        className="btn btn-primary btn-lg btn-block"
                        type="submit"
                      >
                        Login
                      </button>
                      <div className="bottom">
                        {/* <span className="helper-text m-b-10">
                          <i className="fa fa-lock"></i>{" "}
                          <a href={`${process.env.PUBLIC_URL}/forgotpassword`}>
                            Forgot password?
                          </a>
                        </span> */}
                        {/* <span>
                          Don't have an account? <a href="registration">Register</a>
                        </span> */}
                      </div>
                      {this.state.errorMessage && (
                        <div className="alert alert-danger" role="alert">
                          {this.state.errorMessage}
                        </div>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  updateUsername: PropTypes.func.isRequired,
  updatePassword: PropTypes.func.isRequired,
  onLoggedin: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
};

const mapStateToProps = ({ loginReducer }) => ({
  username: loginReducer.username,
  password: loginReducer.password,
});

export default connect(mapStateToProps, {
  updateUsername,
  updatePassword,
  onLoggedin,
})(Login);
